import { render, staticRenderFns } from "./OverView.vue?vue&type=template&id=64a3c66e&scoped=true"
import script from "./OverView.vue?vue&type=script&lang=js"
export * from "./OverView.vue?vue&type=script&lang=js"
import style0 from "./OverView.vue?vue&type=style&index=0&id=64a3c66e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3c66e",
  null
  
)

export default component.exports